import { render, staticRenderFns } from "./CoolingStagesForm.vue?vue&type=template&id=138a61b4&scoped=true&"
import script from "./CoolingStagesForm.vue?vue&type=script&lang=js&"
export * from "./CoolingStagesForm.vue?vue&type=script&lang=js&"
import style0 from "./CoolingStagesForm.vue?vue&type=style&index=0&id=138a61b4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a61b4",
  null
  
)

export default component.exports